import { type Country } from 'services'

const phoneMasks: Record<string, string> = {
  Afghanistan: '(+\\93) 99-999-9999',
  Albania: '(+355) 99-999-999',
  Algeria: '(+213) (9)-99-99-99-99',
  'American Samoa': '(+1) 999-999-9999',
  Andorra: '(+376) 999-999',
  Angola: '(+244) 999-999-999',
  Anguilla: '(+1) (999)-999-9999',
  Antarctica: '',
  'Antigua and Barbuda': '(+1) (999)-999-9999',
  Argentina: '(+54) 99-9999-9999',
  Armenia: '(+374) 99-999-999',
  Aruba: '(+2\\97) 999-9999',
  Australia: '(+61) 9-9999-9999',
  Austria: '(+43) 999-999999999',
  Azerbaijan: '(+\\9\\94) 99-999-99-99',
  Bahamas: '(+1) (999)-999-9999',
  Bahrain: '(+\\973) 9999-9999',
  Bangladesh: '(+880) 1999-999999',
  Barbados: '(+1) (999)-999-9999',
  Belarus: '(+375) 999-99-9999',
  Belgium: '(+32) 999-99-99-99',
  Belize: '(+501) 999-9999',
  Benin: '(+22\\9) 99-99-99-99',
  Bermuda: '(+1) (999)-999-9999',
  Bhutan: '(+\\975) 99-99-99-99-99',
  Bolivia: '(+5\\91) 9999-9999',
  'Bosnia and Herzegovina': '(+387) 99-999-999',
  Botswana: '(+267) 99-999-999',
  'Bouvet Island': '',
  Brazil: '(+55) 99-99999-9999',
  'British Indian Ocean Territory': '(+246) 99-999-999',
  'British Virgin Islands': '(+1) (999)-999-9999',
  Brunei: '(+673) 9999-999',
  Bulgaria: '(+35\\9) 999-999-999',
  'Burkina Faso': '(+226) 99-99-99-99',
  Burundi: '(+257) 99-99-99-99',
  Cambodia: '(+855) 99-999-999',
  Cameroon: '(+237) 99-99-99-99',
  Canada: '(+1) 999-999-9999',
  'Cape Verde': '(+238) 999-99-99',
  'Cayman Islands': '(+1) (999)-999-9999',
  'Central African Republic': '(+236) 99-99-99-99',
  Chad: '(+235) 99-99-99-99',
  Chile: '(+56) 9-9999-9999',
  China: '(+86) 999-9999-9999',
  'Christmas Island': '(+61) 9-9999-9999',
  'Cocos (Keeling) Islands': '(+61) 9-9999-9999',
  Colombia: '(+57) 999-999-9999',
  Comoros: '(+26\\9) 9999-99-99',
  'Cook Islands': '(+682) 99-999',
  'Costa Rica': '(+506) 9999-9999',
  Croatia: '(+385) 99-999-9999',
  Cuba: '(+53) 9-9999999',
  Curacao: '(+5\\9\\9) 9-999-9999',
  Cyprus: '(+357) 99-999999',
  'Czech Republic': '(+420) 999-999-999',
  Denmark: '(+45) 99-99-99-99',
  Djibouti: '(+253) 99-99-99-99',
  Dominica: '(+1) (767)-999-9999',
  'Dominican Republic': '(+1) (999)-999-9999',
  'DR Congo': '(+243) 999-999-999',
  Ecuador: '(+5\\93) 99-999-9999',
  Egypt: '(+20) 99-999-9999',
  'El Salvador': '(+503) 9999-9999',
  'Equatorial Guinea': '(+240) 999-999-999',
  Eritrea: '(+2\\91) 99-999-9999',
  Estonia: '(+372) 9999-9999',
  Ethiopia: '(+251) 99-999-9999',
  'Falkland Islands': '(+500) 9999-9999',
  'Faroe Islands': '(+2\\98) 999-999',
  Fiji: '(+679) 999-9999',
  Finland: '(+358) 99-9999999',
  France: '(+33) 9-99-99-99-99',
  'French Guiana': '(+5\\94) 9999-99-99-99',
  'French Polynesia': '(+68\\9) 99-99-99-99',
  'French Southern and Antarctic Lands': '(+262) 999-99-99-99',
  Gabon: '(+241) 99-99-99-99',
  Gambia: '(+220) 999-9999',
  Georgia: '(+\\9\\95) 99-999-9999',
  Germany: '(+4\\9) 999-99999999',
  Ghana: '(+233) 99-999-9999',
  Gibraltar: '(+350) 999-99999',
  Greece: '(+30) 999-999-9999',
  Greenland: '(+2\\9\\9) 99-99-99',
  Grenada: '(+1) (473)-999-9999',
  Guadeloupe: '(+5\\90) 99-99-99-99',
  Guam: '(+1) (671)-999-9999',
  Guatemala: '(+502) 9999-9999',
  Guernsey: '(+44) (1481)-999-999',
  Guinea: '(+224) 99-99-99-99',
  'Guinea-Bissau': '(+245) 9-99-99-99',
  Guyana: '(+5\\92) 999-9999',
  Haiti: '(+50\\9) 99-99-99-99',
  'Heard Island and McDonald Islands': '(+672) 9999-9999',
  Honduras: '(+504) 9999-9999',
  'Hong Kong SAR': '(+852) 9999-9999',
  Hungary: '(+36) 99-999-999',
  Iceland: '(+354) 999-9999',
  India: '(+\\91) 99 9999 9999',
  Indonesia: '(+62) 99-9999-99999',
  Iran: '(+\\98) 9999-999-999',
  Iraq: '(+\\964) 999-999-9999',
  Ireland: '(+353) 99-999-9999',
  'Isle of Man': '(+44) 1624-999999',
  Israel: '(+\\972) 999-999-999',
  Italy: '(+3\\9) 99-99999-9999',
  'Ivory Coast': '(+225) 99-99-99-99',
  Jamaica: '(+1) (999)-999-9999',
  Japan: '(+81) 99-9999-9999',
  Jersey: '(+44) 9999-999999',
  Jordan: '(+\\962) 9-9999-9999',
  Kazakhstan: '(+7) 999-999-9999',
  Kenya: '(+254) 999-999-999',
  Kiribati: '(+686) 99999',
  Kosovo: '(+383) 99-999-999',
  Kuwait: '(+\\965) 9999-9999',
  Kyrgyzstan: '(+\\9\\96) 999-999-999',
  Laos: '(+856) 99-99-999-999',
  Latvia: '(+371) 99-99-99-99',
  Lebanon: '(+\\961) 9-999-999',
  Lesotho: '(+266) 9-99-99-99',
  Liberia: '(+231) 99-999-999',
  Libya: '(+218) 99-999-9999',
  Liechtenstein: '(+423) 99-999-99-99',
  Lithuania: '(+370) 9-99-99999',
  Luxembourg: '(+352) 9-99-99-99',
  Macau: '(+853) 99-999-999',
  Macedonia: '(+38\\9) 99-999-999',
  Madagascar: '(+261) 99-99-999 99',
  Malawi: '(+265) 99-999-9999',
  Malaysia: '(+60) 99-999-9999',
  Maldives: '(+\\960) 999-9999',
  Mali: '(+223) 99-99-99-99',
  Malta: '(+356) 99-999-999',
  'Marshall Islands': '(+692) 999-9999',
  Martinique: '(+5\\96) 99-99-99-99',
  Mauritania: '(+222) 99-99-99-99',
  Mauritius: '(+230) 9-999-9999',
  Mayotte: '(+262) 999-99-99-99',
  Mexico: '(+52) 99-9999-9999',
  Micronesia: '(+6\\91) 9-99-99-99',
  Moldova: '(+373) 99-999-999',
  Monaco: '(+377) 9-99-99-99-99',
  Mongolia: '(+\\976) 99-99-99-99',
  Montenegro: '(+382) 99-999-999',
  Montserrat: '(+1) (999)-999-9999',
  Morocco: '(+212) 9-99-99-99-99',
  Mozambique: '(+258) 99-999-9999',
  Myanmar: '(+\\95) 9-9999-9999',
  Namibia: '(+264) 99-999-9999',
  Nauru: '(+674) 999-9999',
  Nepal: '(+\\977) 99-9999-9999',
  Netherlands: '(+31) 9-99999999',
  'New Caledonia': '(+687) 99.99.99',
  'New Zealand': '(+64) 99-999-9999',
  Nicaragua: '(+505) 8999-9999',
  Niger: '(+227) 99-99-99-99',
  Nigeria: '(+234) 9-9999-9999',
  Niue: '(+683) 9999',
  'Norfolk Island': '(+672) 9-9999',
  'North Korea': '(+850) 999-9999-9999',
  'Northern Mariana Islands': '(+1) (999)-999-9999',
  Norway: '(+47) 99-99-99-99',
  Oman: '(+\\968) 9999-9999',
  Pakistan: '(+\\92) 9999-9999999',
  Palau: '(+680) 999-9999',
  Palestine: '(+\\970) 599-999-999',
  Panama: '(+507) 999-9999',
  'Papua New Guinea': '(+675) 9999-9999',
  Paraguay: '(+5\\95) 999-999999',
  Peru: '(+51) 999-999-999',
  Philippines: '(+63) 999-999-9999',
  'Pitcairn Islands': '(+\\9\\9\\9) 99999',
  Poland: '(+48) 999-999-999',
  Portugal: '(+351) 999-999-999',
  'Puerto Rico': '(+1) 999-999-9999',
  Qatar: '(+\\974) 9999-9999',
  'Republic of the Congo': '(+242) 99-999-999-999',
  Reunion: '(+262) 9999-9999',
  Romania: '(+40) 99-999-9999',
  Russia: '(+7) 999-999-99-99',
  Rwanda: '(+250) 9999-999-999',
  'Saint Barthelemy': '(+5\\90) 999-99-99-99',
  'Saint Helena': '(+2\\90) 9999-9999',
  'Saint Kitts and Nevis': '(+1) (999)-999-9999',
  'Saint Lucia': '(+1) (999)-999-9999',
  'Saint Martin': '(+5\\90) 999-99-99-99',
  'Saint Pierre and Miquelon': '(+508) 999-99-99',
  'Saint Vincent and the Grenadines': '(+1) (999)-999-9999',
  Samoa: '(+685) 9999-9999',
  'San Marino': '(+378) 999-99-999',
  'Sao Tome and Principe': '(+23\\9) 9999-9999',
  'Saudi Arabia': '(+\\966) 99-999-9999',
  Senegal: '(+221) 99-999-99-99',
  Serbia: '(+381) 99-999-9999',
  Seychelles: '(+248) 9-999-999',
  'Sierra Leone': '(+232) 99-999-999',
  Singapore: '(+65) 9999-9999',
  'Sint Maarten': '(+1) (999)-999-9999',
  Slovakia: '(+421) 999-999-999',
  Slovenia: '(+386) 99-999-999',
  'Solomon Islands': '(+677) 99999',
  Somalia: '(+252) 9-999-9999',
  'South Africa': '(+27) 99-999-9999',
  'South Georgia': '(+500) 99999',
  'South Korea': '(+82) 99-999-9999',
  'South Sudan': '(+211) 999-999-999',
  Spain: '(+34) 999-99-99-99',
  'Sri Lanka': '(+\\94) 99-999-9999',
  Sudan: '(+24\\9) 999-999-999',
  Suriname: '(+5\\97) 999-9999',
  'Svalbard and Jan Mayen': '(+47) 999-99-999',
  Swaziland: '(+268) 9999-9999',
  Sweden: '(+46) 99-999-9999',
  Switzerland: '(+41) 99-999-99-99',
  Syria: '(+\\963) 999-999-999',
  Taiwan: '(+886) 99-9999-9999',
  Tajikistan: '(+\\9\\92) 999-999-999',
  Tanzania: '(+255) 99-999-9999',
  Thailand: '(+66) 99-999-9999',
  'Timor-Leste': '(+670) 99-999-999',
  Togo: '(+228) 99-99-99-99',
  Tokelau: '(+6\\90) 99-999',
  Tonga: '(+676) 99-999',
  'Trinidad and Tobago': '(+1) (999)-999-9999',
  Tunisia: '(+216) 99-999-999',
  Turkey: '(+\\90) 999-999-99-99',
  Turkmenistan: '(+\\9\\93) 99-999-999',
  'Turks and Caicos Islands': '(+1) (999)-999-9999',
  Tuvalu: '(+688) 9999',
  Uganda: '(+256) 99-999-9999',
  Ukraine: '(+380) 99-999-9999',
  'United Arab Emirates': '(+\\971) 99-999-9999',
  'United Kingdom': '(+44) 9999-999-999',
  'United States': '(+1) (999)-999-9999',
  'United States Minor Outlying Islands': '(+1) (999)-999-9999',
  'United States Virgin Islands': '(+1) (999)-999-9999',
  Uruguay: '(+5\\98) 999-99-99-99',
  Uzbekistan: '(+\\9\\98) 99-999-99-99',
  Vanuatu: '(+678) 999-9999',
  'Vatican City': '(+3\\9) 99-9999-9999',
  Venezuela: '(+58) 999-999-9999',
  Vietnam: '(+84) 99-9999-9999',
  'Wallis and Futuna': '(+681) 99-99-99',
  'Western Sahara': '(+212) 99-99-99-99',
  Yemen: '(+\\967) 999-999-999',
  Zambia: '(+260) 99-999-9999',
  Zimbabwe: '(+263) 999-999-999'
}

export const applyPhoneMask = (phone: string | null = '', country: Country | null): string => {
  if (phone == null || country == null) {
    return ''
  }

  const sanitizedPhone = phone != null ? phone.trim() : ''
  if (sanitizedPhone === '' || sanitizedPhone.includes(country.country_code == null ? '' : country.country_code)) {
    return phone
  }

  let result = ''
  let phoneIndex = 0
  const mask = getPhoneMask(country?.country_desc ?? '')

  for (let i = 0; i < mask.length; i++) {
    const maskChar: string = mask[i]

    if (maskChar === '9' && phoneIndex < phone.length) {
      result += phone[phoneIndex]
      phoneIndex++
    } else {
      result += maskChar
    }
  }

  return result
}

export function getPhoneMask (countryName: string): string {
  return countryName in phoneMasks ? phoneMasks[countryName] : ''
}

export function fullPhone (countryCode: string | null = '', phoneNumber: string | null = ''): string {
  return `${countryCode ?? ''}${phoneNumber ?? ''}`
}
